import { useQuery } from '@tanstack/react-query';
import { AuthError } from 'firebase/auth';
import { getEmailByOobcode } from 'shared/services/backend-api';
import { getErrorReporter } from 'shared/services/error-tracking';

export const queryKey = 'get-email-by-oob-code';

// The email is display-only (it pre-fills the read-only field). A genuinely
// invalid link must surface (re-thrown for the invalid-link fallback), but a
// transient failure must not blank/crash the page — resolve to null instead.
export const resolveEmailForDisplay = async (
  oobCode: string,
): Promise<string | null> => {
  try {
    return await getEmailByOobcode(oobCode);
  } catch (error) {
    if ((error as AuthError).code === 'auth/invalid-action-code') {
      throw error;
    }

    getErrorReporter().captureException(error, {
      tags: { source: 'verify-password-reset-code' },
    });

    return null;
  }
};

export const useEmailByOobCodeQuery = (oobCode?: string) =>
  useQuery({
    queryKey: [queryKey, oobCode],
    queryFn: () => (oobCode ? resolveEmailForDisplay(oobCode) : null),
    enabled: !!oobCode,
    throwOnError: true,
  });
